<form [formGroup]="form" (ngSubmit)="onSave()">
  <div class="k-form">
    <h3>{{this.customMsgService.translate('prePagoReserva')}}</h3>
    <div class="k-form-field" *ngFor="let prePago of prePagoControls; let i = index" style="display: flex; align-items: center; margin-bottom: 10px;">
      <label [for]="'precoPrePago' + i" style="margin-right: 10px;">{{ prePago.label }}</label>
      <kendo-numerictextbox
        [formControl]="prePago.control"
        format="#.00 €"
        [step]="0.05"
        [min]="0"
        [id]="'precoPrePago' + i"
        style="flex: 1;"
      ></kendo-numerictextbox>
      <div *ngIf="prePago.control.hasError('invalidDecimal')">
      </div>
    </div>

    <h3>{{this.customMsgService.translate('posPagoHorasExtra')}}</h3>
    <div class="k-form-field" *ngFor="let posPago of posPagoControls; let i = index" style="display: flex; align-items: center; margin-bottom: 10px;">
      <label [for]="'precoPosPago' + i" style="margin-right: 10px;">{{ posPago.label }}</label>
      <kendo-numerictextbox
        [formControl]="posPago.control"
        format="#.00 €"
        [step]="0.05"
        [min]="0"
        [id]="'precoPosPago' + i"
        style="flex: 1;"
      ></kendo-numerictextbox>
      <div *ngIf="posPago.control.hasError('invalidDecimal')">
      </div>
    </div>
    <div class="k-form-buttons">
      <button kendoButton (click)="form.reset()">
          {{ customMsgService.translate('cancel') }}
      </button>
      <button kendoButton [primary]="true" [disabled]="form.invalid">
          {{ customMsgService.translate('saveChanges') }}
      </button>
  </div>
  </div>
</form>
